import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { ReactState } from '../Types/Types'
import { UserInfo, useUserInfo } from '../../../ReactRouting/Hooks/useUserInfo'
import { CMEResponse } from '../../../NonReact/Types/Types'
import { isBitmaskMatching } from '../Utils/BitwiseOperations'
import { CapabilityBitFlags } from '../../CMEAddModify/Constants'
import { getCMEInternal } from '../../../NonReact/common/API/EntityAPIClient'

export const useIsCXIEnabled = (): boolean => {
    const [userInfo]: UserInfo = useUserInfo()
    const [isClientConfigEnabled, setIsClientConfigEnabled]: ReactState<boolean> = useState<boolean>(false)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        if (userInfo?.Scope?.CMEnvironmentID) {
            getCMEInternal(userInfo.Scope.CMEnvironmentID)
                .then((cme: Nullable<CMEResponse>): void => {
                    if (isMounted.current) {
                        setIsClientConfigEnabled(
                            isBitmaskMatching(cme?.Capabilities ?? 0, CapabilityBitFlags.CXI_BROADWORKS) ||
                                isBitmaskMatching(cme?.Capabilities ?? 0, CapabilityBitFlags.CXI_WEBEX) ||
                                isBitmaskMatching(cme?.Capabilities ?? 0, CapabilityBitFlags.CXI_TEAMS)
                        )
                    }
                })
                .catch((): void => {
                    setIsClientConfigEnabled(false)
                })
        }
    }, [userInfo])

    return isClientConfigEnabled
}
